<div class="topDiv" [style.background-color]="backgroundColorScreen">
  <div class="agGridOuterDiv">
    <div>
      <mat-toolbar
        class="agGridtoperDiv card"
        style="
          background: rgb(228 227 230 / 41%);
          border-top: 1px solid #a9a9a9a8;
          border-right: 1px solid #a9a9a9a8;
          border-left: 1px solid #a9a9a9a8;
        "
      >
        <label i18n="@@spmsUserReg" class="textColour">Release Library</label>

        <span class="example-spacer"></span>
       <app-common-button
         
          title="Refresh"
          label="Refresh"
		  icon="fas fa-sync-alt"
         [buttonId]="1111"
          
     
          (clicked)="onRefresh()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
          <app-common-button
        icon="fas fa-download"
  
           title="Download "
           label="Download"
          [buttonId]="1111"
         
       
          (clicked)="onDownload()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
       <app-common-button
        label="Create"
          title="Create"
          icon="fas fa-plus-circle"
          [buttonId]="114"
         
    
          (clicked)="onCreate()"
          style="margin-right:1%"
          >
      </app-common-button>
        <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@Targetpageno">Page No</mat-label>
            <input
              matInput
              type="text"
              (input)="onSearchChange($event.target.value)"
            />
          </mat-form-field>
        </div>
        <div class="selectRecordsDiv" style="width: 9.5%">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label i18n="@@Targetrecords" style="color: black"
              >Records</mat-label
            >
            <mat-select
              [(ngModel)]="pageSize"
              (ngModelChange)="onPageSizeChanged($event)"
            >
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="card pagination paginationFirstButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onBtFirst()"
          ></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
          <ul>
            <li class="paginationliicon">
              <em
                class="fas fa-angle-left waves-effect waves-light"
                (click)="onBtPrevious()"
              ></em>
            </li>
            <li>{{ currentPage }}/{{ totalPages }}</li>
            <li class="paginationliicon" style="padding: 0">
              <em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onBtNext()"
              ></em>
            </li>
          </ul>
        </div>
        <div
          class="card pagination paginationLastButton paginationFirstlastButton"
        >
          <em
            class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onBtLast()"
          ></em>
        </div>
      </mat-toolbar>
    </div>

    <ag-grid-angular
      class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
      [columnDefs]="columnDefs"
      [animateRows]="true"
      [pagination]="true"
      [rowData]="rowData"
      [rowSelection]="rowSelection"
      [defaultColDef]="defaultColDef"
      [suppressPaginationPanel]="true"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize"
      [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true"
      [components]="components"
      [debug]="true"
      [getRowStyle]="getRowStyle"
      [rowClassRules]="rowClassRules"
      (paginationChanged)="onPaginationChangedReturn()"
      (gridReady)="onGridReady($event)"
      [hidden]="!true"
     
    ></ag-grid-angular>
  </div>
</div>